import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./Sales'),
  (m) => m.default
);
